import { VoiceStatuses } from './types';
import { getPhrases } from './apiUtils';
import { getDebugType, getIsSIMD, voicePredict, isValidVoice, arrayToTextDownload } from './utils';
import { voiceParams } from './constants';

let stream: MediaStream;
let isSimd = false;
const recordDuration = 5;

const debugType = getDebugType();
getIsSIMD().then(simd => isSimd = simd)

/**
 * @ignore
 */
export const openMic = async (domElement: string): Promise<{ stream: MediaStream }> => {
  try {
    const constraints = {
      audio: voiceParams,
      video: false,
    };

    const stream: MediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    const element: HTMLAudioElement = document.getElementById(domElement) as HTMLAudioElement;
    element.srcObject = stream;

    if (document.getElementById(domElement)) {
      new Promise<void>((resolve) => element.addEventListener('loadeddata', () => resolve()));
    }

    console.log('Stream', element);
    return { stream };
  } catch (e) {
    console.error('Error while getAccessToCamera', e);
    return null;
  }
};

/**
 * @ignore
 */

export const recordVoice = async (action: boolean,
  playerRef: string,
  callback: (input: { status: VoiceStatuses; phrases?: string[]; stream?: MediaStream; progress?: number }) => void,
): Promise<{result: number, voiceData: Uint8ClampedArray}> =>
 new Promise(async (resolve) => {
  console.log('--------recordVoice--------');
  
  let recording;
  let progress = 0;
  try {
    if (!stream) {
      const { stream: mic } = await openMic(playerRef);
      stream = mic;
    }

    const phrases = await getPhrases();
    callback({ status: VoiceStatuses.SET_PHRASES, phrases });

    const timer = setInterval(() => {
      progress++;
      callback({ status: VoiceStatuses.SET_PROGRESS, progress });
    }, 1000);

    callback({ status: VoiceStatuses.START_RECORDING, stream });

    const recorder = new MediaRecorder(stream);

    recorder.start();

    recorder.ondataavailable = async (e) => {

      recording = await e.data.arrayBuffer()
      const resultVoice = await isValidVoice(recording, false, voiceParams, recordDuration, isSimd, '0')
      // arrayToTextDownload(data, `${Date.now  }.txt`)
      resolve(resultVoice)
    };

    await new Promise(async (resolve) => {
      setTimeout(() => {
        progress = 0;
        recorder.stop();
        clearInterval(timer);
        callback({ status: VoiceStatuses.RECORDING_DONE });
        resolve('success')
      }, recordDuration * 1000);
    })
  } catch (err) {
    console.error(err);
  }
});

export async function voiceEnrollPredict(
  action: boolean,
  playerRef: string,
  callback: (input: { status: VoiceStatuses; phrases?: string[]; stream?: MediaStream; progress?: number, result: string }) => void,
) {
  const {result, voiceData} = await recordVoice(action, playerRef, callback);

  const wasmResult = await voicePredict(voiceData);

  if (wasmResult !== -1) {
    // const response = await read(wasmResult);
    //
    // const decoded = new TextDecoder().decode(response.contents);
    // if (debugType !== '0') console.log('----decoded', decoded);

    try {
      // const returnValue = JSON.parse(decoded);
      callback({ status: VoiceStatuses.PREDICTION_DONE, result: Math.random() > 0.5 ? 'success' : 'failure' });

      await new Promise(async (resolve) => {
        setTimeout(() => {
          console.log(voiceData, '---PREDICTION_DONE---')
          resolve(1)
        }, 2000);
      });
    } catch (error) {
      console.log('Error occured in parsing: ', error);
    }
  }
}

export async function continousVoicePredict(
  action: boolean,
  playerRef: string,
  callback: (input: { status: VoiceStatuses; phrases?: string[]; stream?: MediaStream; progress?: number }) => void,
) {
  const location = window.location.pathname;
  const {result, voiceData} = await recordVoice(action, playerRef, callback);

  console.log(voiceData, '-----voiceData-----', result, '-----result-----')
  const wasmResult = await voicePredict(voiceData);

  if (wasmResult !== -1) {
    // const response = await read(wasmResult);
    //
    // const decoded = new TextDecoder().decode(response.contents);
    // if (debugType !== '0') console.log('----decoded', decoded);

    try {
      // const returnValue = JSON.parse(decoded);
      callback({ status: VoiceStatuses.PREDICTION_DONE });

      await new Promise(async (resolve) => {
        setTimeout(() => {
          console.log(voiceData, '---PREDICTION_DONE---')
          resolve(1)
        }, 2000);
      });

      // if ((!action && location !== '/enroll') || (action && returnValue.status !== 0)) {
        // await continousVoicePredict(action, playerRef, callback);
      // }
    } catch (error) {
      console.log('Error occured in parsing: ', error);
    }
  }
}
